/**
 * Feishu scopes for RAG document ingestion OAuth.
 * Keep in sync with backend `feishuRAGOAuthScopes` in
 * `backend/pkg/server/manager/public/feishu_oauth.go`.
 */
export const FEISHU_RAG_RECOMMENDED_PERMISSIONS: ReadonlyArray<{
  scope: string;
  label: string;
}> = [
  { scope: 'docx:document:readonly', label: '查看云文档' },
  { scope: 'drive:drive:readonly', label: '查看云空间' },
  { scope: 'drive:file:readonly', label: '查看、下载云空间文件' },
  { scope: 'wiki:wiki:readonly', label: '查看知识库' },
  { scope: 'contact:user.base:readonly', label: '获取用户基本信息' },
  { scope: 'board:whiteboard:node:read', label: '查看白板节点' },
  { scope: 'drive:drive.metadata:readonly', label: '查看云空间元数据' },
  { scope: 'sheets:spreadsheet:readonly', label: '查看电子表格' },
  { scope: 'bitable:app:readonly', label: '查看多维表格' },
] as const;
